/**
 * StepPlaceholder — stands in for the steps that are not built yet, so the
 * flow can be walked end to end while it is being designed step by step.
 * Replace each with its real component as it lands.
 */
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { STEPS, DONE_KEY } from '../steps.js';
import StepFooter from './StepFooter.js';

export default function StepPlaceholder({ stepKey, goNext, goBack, exit, strips }) {
  const { t } = useTranslation();
  const idx = STEPS.findIndex((s) => s.key === stepKey);
  const isDone = stepKey === DONE_KEY;
  const label = isDone ? t('ac_done_label') : t(STEPS[idx]?.labelKey || 'ac_step_start');
  return (
    <>
      <header className="ac-head">
        <h2 className="ac-title">{label}</h2>
        <p className="ac-sub">{t('ac_placeholder_sub')}</p>
      </header>
      <div className="ac-body">
        <div className="ac-placeholder">
          <FontAwesomeIcon icon={faWandMagicSparkles} />
          <span>{t('ac_placeholder_body')}</span>
        </div>
        {strips}
      </div>
      <StepFooter
        onBack={idx > 1 ? goBack : null}
        primaryLabel={isDone ? t('ac_done_open') : t('continue')}
        onPrimary={isDone ? exit : goNext}
      />
    </>
  );
}
